import { useEffect } from 'react';
import { Outlet, useMatch } from 'react-router-dom';
import { Sidebar } from '@/components/layout/Sidebar';
import { Topbar } from '@/components/layout/Topbar';
import { useAuthStore } from '@/store/authStore';

/**
 * Shared shell for every signed-in portal. Everything renders in Studio
 * (light, the document default); only photo stages opt into the dark token
 * set with data-theme="dark" (UI_GUIDELINES §1).
 *
 * The platform shows one competition at a time. Opening a competition (or any
 * organizer page scoped to one) makes it the active one, which is what the
 * sidebar and the role-dependent pages follow.
 */
export function AppLayout() {
  const setActiveCompetitionId = useAuthStore((s) => s.setActiveCompetitionId);
  const activeCompetitionId = useAuthStore((s) => s.activeCompetitionId);
  const publicMatch = useMatch('/competitions/:competitionId');
  const organizerMatch = useMatch('/organizer/competitions/:competitionId/*');
  const urlCompetitionId = publicMatch?.params.competitionId ?? organizerMatch?.params.competitionId ?? null;

  useEffect(() => {
    if (urlCompetitionId && urlCompetitionId !== activeCompetitionId) setActiveCompetitionId(urlCompetitionId);
  }, [urlCompetitionId, activeCompetitionId, setActiveCompetitionId]);

  return (
    <div className="flex min-h-screen bg-surface-0 text-fg">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-6 md:px-8 md:py-8">
          <div className="animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
